import React, {ReactElement} from 'react';
import {Button, ButtonProps} from '@material-ui/core';

const PrimaryButton: React.FC<ButtonProps> = (props): ReactElement => {
  const {children, className, ...rest} = props;
  return (
    <Button
      color="primary"
      variant="contained"
      className={['button-base secondary', className].join(' ')}
      {...rest}>
      {children}
    </Button>
  );
};

export default PrimaryButton;
